export class CloseVideoDialogEvent extends Event {

    constructor() {
        super("closeVideoDialog");
    }

}

declare global {
    interface WindowEventMap {
        closeVideoDialog: CloseVideoDialogEvent;
    }
}